import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: start;
	gap: 15px;
	overflow-y: hidden;
`;

export const CardsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	padding: 20px 0px 6vh 0px;
	row-gap: 4vh;
	column-gap: 1vw;
	overflow-x: auto;
	max-height: 50vh;

	> div:first-child {
		background-color: ${tokens.color_gray_light};
		p:first-child {
			font-weight: 600;
		}
	}

	@media (max-width: 1390px) {
		grid-template-columns: 1fr;
	}
	@media (max-width: 1580px) {
		max-height: 38vh;
	}
	@media (max-width: 1450px) {
		max-height: 33vh;
	}
`;
